import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from 'components/Container'
import { Button } from 'components/Button'
import { TPageProps } from 'models/common.model'
import smilingWomen from 'assets/images/smiling-women.png'
import { Review } from 'components/Review'
import { triggerClickOnCanvas } from 'helpers/triggerClickOnCanvas'
import { useNextStep } from 'hooks/useNextStep'
import { StyledCustomerReviews as S } from './CustomerReviews.styles'
import { CUSTOMER_REVIEW, QUESTION } from './constants'

export const CustomerReviews: FC<TPageProps> = ({ pageId, nextPagePath }) => {
  const { t } = useTranslation()

  const handleContinue = useNextStep({
    pageId,
    question: QUESTION,
    nextPagePath,
  })

  const handleNextClick = useCallback(
    (event) => {
      triggerClickOnCanvas(event)
      handleContinue('')
    },
    [handleContinue],
  )

  return (
    <Container>
      <S.ImageContainer>
        <img src={smilingWomen} alt="smiling-women" />
      </S.ImageContainer>
      <Review
        author={CUSTOMER_REVIEW.author}
        text={t(CUSTOMER_REVIEW.text as any)}
      />
      <Button onClick={handleNextClick}>{t('actions.continue')}</Button>
    </Container>
  )
}
